<template lang="pug">
    .container.content(v-if="image" ref="container")
        .columns.is-vcentered
            .column
                .image
                    figure
                        img(
                            v-lazy="image"
                            :title="title || subTitle"
                            rel="noopener")
            .column
                div.has-text-white.is-size-5(v-if="text" v-html="text")
</template>

<script>

import _ from 'lodash'

export default {
    name: 'jumbotron',
    data() {
        return {
            maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        content() {
            return this.section.contents.find(content => content.key === 'content') 
        },
        text() {
            return _.get(this.content, 'text')
        },
        width() {
            if (this.image.width && this.maxW) return _.min([this.image.width, this.maxW])
            else return undefined
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        image() {
            const imageContent = this.section.contents.find(content => content.key === 'image') 
            const image = _.get(imageContent, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            height = Math.min(window.innerWidth >= 1088 ? 780 : 400, height)
            width = height * aspectRatio

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(window.innerWidth >= 1088 ? 780 : 400, image.height / fz)
                width = height * aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .content
        padding-bottom: 2.5rem
        .image
            figure
                display: block
                margin-bottom: 2px
                border-radius: 20px
                img
                    width: auto
                    height: auto
                    border-radius: 20px
                    display: inline-block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        // max-height: 500px
                        // height: initial !important
                        // width: initial !important
                        box-shadow: $box-shadow-3
            p
                margin-bottom: 0
                font-size: .8rem
            small
                font-size: .65rem
                display: block
</style>
